<template>
	<div class="paging_board">
		<a href="javascript:" class="btn_page btn_prev" :disabled="isFirstPage" @click="toPrevPage()">
			<span class="ico_cafe ico_prev">이전페이지</span>
		</a>
		<span id="pagingNav" class="desc_paging">
			<span class="sr_only">현재페이지</span>
			<span v-for="i in pageList" class="num_page">
				<em v-if="page===i" class="link_page">{{i+1}}</em>
				<a v-else href="javascript:" class="link_page" @click="goToPage(i)">{{i+1}}</a>
			</span>
		</span>
		<a href="javascript:" class="btn_page btn_next" :disabled="isLastPage" @click="toNextPage()">
			<span class="ico_cafe ico_next">다음페이지</span>
		</a>
	</div>
</template>

<script>
	export default {
		props: ['page', 'maxPage'],
		computed: {
			isFirstPage: function () {
				return this.page === 0;
			},
			isLastPage: function () {
				return this.page + 1 === this.maxPage;
			},

			pageList: function () {
				const floor = Math.floor(this.page / 5) * 5;
				const length = Math.min(5, this.maxPage - floor);

				return [...Array(length).keys()].map(v => v + floor);
			}
		},

		methods: {
			toNextPage: function () {
				if (this.isLastPage) return;
				this.goToPage(this.page + 1);
			},
			toPrevPage: function () {
				if (this.isFirstPage) return;
				this.goToPage(this.page - 1);
			},
			goToPage: function (page) {
				scroll(0, 0);
				this.$emit('page-select', page);
			}
		}
	}
</script>
